<template>
    <div>
        <div id="worksends-page-header" class="tw-mb-3">
          <div class="breadcrumbs" id="breadcrumbs">
            <router-link class="breadcrumb-link" to="/corporate-products/">All Corporate Products</router-link> &gt;
            <router-link class="breadcrumb-link" to="/corporate-products/requests">Product Requests</router-link>
          </div>
            <h3>Your Corporate Product Requests<span class="preview" v-if="team.plan!='pro'"> PREVIEW</span></h3>
            <div class="ws-button ws-button-main" @click="openRequestModal">Request New Product</div>
        </div>
        <table class="worksends-table">
            <thead>
            <tr>
                <th>Product Name</th>
                <th>Product Type</th>
                <th>Request Type</th>
                <th>Status</th>
                <th>Request Date</th>
                <th>Stock Amount</th>
                <th>Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in index.data">
                <td class="field-p_name" data-label="Product Name"><div class="value"><b>{{ item.name }}</b></div></td>
                <td class="field-p_type field-uppercase" data-label="Product Type"><div class="value">{{ item.product_type }}</div></td>
                <td class="field-request_type" data-label="Request Type"><div class="value">{{ item.request_type === 'new' ? 'New Item' : 'Restock'}}</div></td>
                <td class="field-status" data-label="Status" :data-status="item.status"><div class="value">{{ item.status }}</div></td>
                <td class="field-created_at" data-label="Request Date"><div class="value">{{ item.created_at }}</div></td>
                <td class="field-stock" data-label="Stock Amount"><div class="value">{{ item.stock }}</div></td>
                <td class="field-actions" data-label="Actions">
                    <div class="value">
                        <router-link v-if="item.request_type === 'new'" class="ws-button small" :to="'/campaigns/corporate-products/requests/' + item.id">View</router-link>
                        <router-link v-if="item.product_id" class="ws-button small" :to="'/corporate-products/' + item.product_id">View Product</router-link>
                        <div v-if="item.status === 'pending' && item.team_id == currentTeamId" class="ws-button small" @click="openEditModal(item)">Edit</div>
                        <div v-if="item.status === 'pending'" class="ws-button small ws-button-negative" @click="cancelRequest(item.id)">Cancel</div>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
        <ws-table-meta :meta="index.meta" sum="You have % product requests."></ws-table-meta>

        <product-requests-modal v-if="modals.productRequestsCreate" :fetch-item="false" @created="onCreated" :type="'create'"></product-requests-modal>
        <product-requests-modal v-if="modals.productRequestsEdit" :fetch-item="true" :request-id="editRequestId" @updated="onUpdated" :type="'edit'"></product-requests-modal>
        <product-restock-modal v-if="modals.productRestock" :fetch-item="true" :product-id="restockProductId" :request-id="editRequestId" :type="'edit'" @updated="onRestockUpdated"></product-restock-modal>

    </div>
</template>

<script>
import ProductRequestsModal from '@/pages/corporate-products/ProductRequestsModal';
import ProductRestockModal from "@/pages/corporate-products/ProductRestockModal";

export default {
    name: "ProductRequestsIndex",
    components: {ProductRequestsModal, ProductRestockModal},
    data() {
        return {
            pageParams: {
                pageOptions: {page:1, sortyBy:[], sortDesc:[], itemPerPage:10},
                search: {val: ""},
                filters: {}
            },
            editRequestId: 0,
            restockProductId: 0,
            errors: {},
        }
    },
    methods: {
        getPage(params) {
            this.getPageHandler({
                waitName: 'product_requests.index',
                action: 'fetchProductRequests', // vuex action
                pageParams: this.pageParams,
                isInit: params ? params.init : false, // parse from url query params
                pushRoute: true, // push pagination params and search q to route
                resetPagination: params ? params.resetPagination : false // new search input -> need to reset page & sorting
            });
        },
        openRequestModal() {
            if (!this.proCheck('Requesting custom products')) return; 
            this.modals.productRequestsCreate = true;
        },
        async cancelRequest(requestId) {
            if (!this.demoCheck()) return;
            
            await this.dispatchWaitAndNotify('updateProductRequest', {requestId, payload: {status:'cancelled'}});
            this.getPage();
        },
        onCreated(id) {
            this.$router.push({ name: 'product-requests-detail', params: { id } });
            this.modals.productRequestsCreate = false;
        },
        onUpdated() {
            this.editRequestId = 0;
            this.modals.productRequestsEdit = false;
            this.getPage();
        },
        onRestockUpdated() {
            this.editRequestId = 0;
            this.restockProductId = 0;
            this.modals.productRestock = false;
            this.getPage();
        },
        openEditModal(item) {
            this.editRequestId = item.id;
            console.log(item);
            if (item.request_type === 'restock') {
                this.restockProductId = item.product_id;
                this.modals.productRestock = true;
            } else {
                this.modals.productRequestsEdit = true;
            }
        },
		async fetchData() {
			await this.dispatchWaitAndNotify('fetchTeam', null, false, true);
		},
    },
    async mounted() {
        this.pageParams.pageOptions.itemsPerPage = this.itemsPerPageCookie(this.$options.name);
		await this.fetchData();
        this.getPage({init:true});
    },
    computed: {
        index() {
            return this.$store.state.product.request.index;
        },
        modals() {
            return this.$store.state.modals;
        },
        currentTeamId() {
            return this.$store.state.teamId;
        },
        team() {
            return this.$store.state.team.detail;
        },
    },
    watch: {
        'pageParams.pageOptions': {
            handler (newVal, oldVal) {
                if (oldVal != null) { // we need to load initial data based on url query instead
                    this.getPage();
                }
            },
            deep: true,
        },
    },
}
</script>
